<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
  display: none;
}

.vue-grid-item {
  background: #26262a;
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419fff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  background: rgb(18, 18, 18);
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: #26262a;
}
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}

.monitorYazhu .el-input__inner {
  color: #419fff;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}

.monitorYazhu .el-cascader .el-input .el-icon-arrow-down {
  color: #419fff;
}

.monitorYazhu .el-input__inner::-webkit-input-placeholder {
  color: #419fff;
}
</style>
<template>
  <div style="display: inline;">
    <div class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;">
      <div ref="header" style="padding: 34px 34px  0px  34px;">
        <div class="module-grid" style="border-radius: 2px;width: 100%;height: 66px;padding:0px 20px;display: flex;justify-content: space-between;align-items: center;">
          <div style="width: 340px;cursor: pointer;">
            <img @click="utils.event_hub.$emit('TOGGLE_TABBAR', !store.state.is_monitor_full)" style="width: 176px;height: 38px;" src="../../../../../../assets/img/web/workshop/logo.png" />
          </div>
          <div style="font-weight: 700;font-size: 30px;color: white;">
            {{ $t('sbnhtpfjkxt') }}
          </div>
          <div class="monitorYazhu" style="width: 340px;display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
            <p style="font-size: 14px;color:white;">{{ store.state.currentTime }}</p>
          </div>
        </div>
      </div>
      <div style="padding: 0px 14px 34px  14px;">
        <grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24" :row-height="gridRowHeihgt" :is-draggable="false" :is-resizable="false" :is-mirrored="false" :vertical-compact="true" :margin="[20, 20]" :use-css-transforms="true" :style="{ height: gridContainerHeight + 'px' }" style="overflow: auto;">
          <grid-item v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
            <component :ref="'grid_' + item.i" v-bind:is="item.i" :datas="datas"> </component>
          </grid-item>
        </grid-layout>
      </div>
    </div>


  </div>
</template>
<script type="text/javascript">
import VueGridLayout from "vue-grid-layout";
import dtznhfb from "@@/pages/web/customize/yzmtpf/monitor/tpf/dtznhfb";
import dyznhfb from "@@/pages/web/customize/yzmtpf/monitor/tpf/dyznhfb";
import jnznhfb from "@@/pages/web/customize/yzmtpf/monitor/tpf/jnznhfb";
import qtnhfx from "@@/pages/web/customize/yzmtpf/monitor/tpf/qtnhfx";

import dtzpffb from "@@/pages/web/customize/yzmtpf/monitor/tpf/dtzpffb";
import dyzpffb from "@@/pages/web/customize/yzmtpf/monitor/tpf/dyzpffb";
import jnzpffb from "@@/pages/web/customize/yzmtpf/monitor/tpf/jnzpffb";
import qttpffx from "@@/pages/web/customize/yzmtpf/monitor/tpf/qttpffx";



import FF240 from "@@/pages/web/customize/yzmtpf/monitor/tpf/FF240";
import UN160A5S from "@@/pages/web/customize/yzmtpf/monitor/tpf/UN160A5S";
import UN300MGII from "@@/pages/web/customize/yzmtpf/monitor/tpf/UN300MGII";


export default {
  name: "web_customize_yzmtpf_monitor_tpf_index",
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    dtznhfb: dtznhfb,
    dyznhfb: dyznhfb,
    jnznhfb: jnznhfb,
    qtnhfx: qtnhfx,
    dtzpffb: dtzpffb,
    dyzpffb: dyzpffb,
    jnzpffb: jnzpffb,
    qttpffx: qttpffx,
    FF240: FF240,
    UN160A5S: UN160A5S,
    UN300MGII: UN300MGII
  },

  data() {
    return {
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      layout: [],
      monitorSetting: {},
      datas: {
        todayTotalEnergy: [0, 0, 0],
        monthTotalEnergy: [0, 0, 0],
        yearTotalEnergy: [0, 0, 0],
        todayTotalCarbon: [0, 0, 0],
        monthTotalCarbon: [0, 0, 0],
        yearTotalCarbon: [0, 0, 0],
        realtimeEnergyConsumption: [0, 0, 0],
        realtimeCarbonEmission: [0, 0, 0],
        realtimeMoldEnergyCon: [0, 0, 0],
        realtimeMoldCarbonCon: [0, 0, 0],
        realtimeMoldMaterialCon: [0, 0, 0],
      },
      timmer: null,
      timmer2: null,
    };
  },
  created() {

    this.setLayout();
    this.utils.event_hub.$emit("TOGGLE_TABBAR", true);

    this.timmer = setInterval(() => {
      this.getEnergyStats();
    }, 6000);
    this.timmer2 = setInterval(() => {
      this.getSumFlowByInterval();
    }, 120000);

    this.getEnergyStats();
    this.getSumFlowByInterval();

  },

  watch: {

  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();

    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });


  },
  destroyed() {
    clearInterval(this.timmer);
    clearInterval(this.timmer2);
    this.utils.event_hub.$off("RESIZE");
  },
  methods: {
    setLayout() {
      this.monitorSetting = JSON.parse(localStorage.getItem("MONITOR_SETTING"));
      if (this.monitorSetting == null) {
        this.monitorSetting = {};
      }
      if (this.monitorSetting.MONITOR_TPF_TEMPLATE == null) {
        this.monitorSetting.MONITOR_TPF_TEMPLATE = "moren";
      }

      if (this.monitorSetting.MONITOR_TPF_TEMPLATES == null) {
        this.monitorSetting.MONITOR_TPF_TEMPLATES = {
          moren: [
            {
              x: 0,
              y: 0,
              w: 6,
              h: 8, //应该是6
              i: "dtznhfb",
            },
            {
              x: 6,
              y: 0,
              w: 6,
              h: 8, //应该是6
              i: "dyznhfb",
            },
            {
              x: 12,
              y: 0,
              w: 6,
              h: 8,
              i: "jnznhfb",
            },
            {
              x: 18,
              y: 0,
              w: 6,
              h: 8,
              i: "qtnhfx",
            },
            {
              x: 0,
              y: 8,
              w: 6,
              h: 8, //应该是18
              i: "dtzpffb",
            },
            {
              x: 6,
              y: 8,
              w: 6,
              h: 8, //应该是18
              i: "dyzpffb",
            },
            {
              x: 12,
              y: 8,
              w: 6,
              h: 8, //应该是18
              i: "jnzpffb",
            },
            {
              x: 18,
              y: 8,
              w: 6,
              h: 8, //应该是18
              i: "qttpffx",
            },
            {
              x: 0,
              y: 16,
              w: 8,
              h: 8, //应该是18
              i: "FF240",
            },
            {
              x: 8,
              y: 16,
              w: 8,
              h: 8, //应该是18
              i: "UN160A5S",
            },
            {
              x: 16,
              y: 16,
              w: 8,
              h: 8, //应该是18
              i: "UN300MGII",
            },
          ],
        };
      }

      this.layout = this.monitorSetting.MONITOR_TPF_TEMPLATES[this.monitorSetting.MONITOR_TPF_TEMPLATE];
    },
    async getEnergyStats() {
      let response = await this.http.get('/custom/yzmtpf/energy/consumption/energyStats', {
        params: {
        }
      });

      let data = {
        todayTotalEnergy: [response.data["FF240"].todayTotalEnergy.toFixed(1), response.data["UN160A5S"].todayTotalEnergy.toFixed(1), response.data["UN300MGII"].todayTotalEnergy.toFixed(1)],
        monthTotalEnergy: [response.data["FF240"].monthTotalEnergy.toFixed(1), response.data["UN160A5S"].monthTotalEnergy.toFixed(1), response.data["UN300MGII"].monthTotalEnergy.toFixed(1)],
        yearTotalEnergy: [response.data["FF240"].yearTotalEnergy.toFixed(1), response.data["UN160A5S"].yearTotalEnergy.toFixed(1), response.data["UN300MGII"].yearTotalEnergy.toFixed(1)],
        todayTotalCarbon: [response.data["FF240"].todayTotalCarbon.toFixed(1), response.data["UN160A5S"].todayTotalCarbon.toFixed(1), response.data["UN300MGII"].todayTotalCarbon.toFixed(1)],
        monthTotalCarbon: [response.data["FF240"].monthTotalCarbon.toFixed(1), response.data["UN160A5S"].monthTotalCarbon.toFixed(1), response.data["UN300MGII"].monthTotalCarbon.toFixed(1)],
        yearTotalCarbon: [response.data["FF240"].yearTotalCarbon.toFixed(1), response.data["UN160A5S"].yearTotalCarbon.toFixed(1), response.data["UN300MGII"].yearTotalCarbon.toFixed(1)],
        realtimeEnergyConsumption: [response.data["FF240"].realtime.energyConsumption.toFixed(1), response.data["UN160A5S"].realtime.energyConsumption.toFixed(1), response.data["UN300MGII"].realtime.energyConsumption.toFixed(1)],
        realtimeCarbonEmission: [response.data["FF240"].realtime.carbonEmission.toFixed(1), response.data["UN160A5S"].realtime.carbonEmission.toFixed(1), response.data["UN300MGII"].realtime.carbonEmission.toFixed(1)],
        realtimeMoldEnergyCon: [response.data["FF240"].realtime.moldEnergyCon.toFixed(1), response.data["UN160A5S"].realtime.moldEnergyCon.toFixed(1), response.data["UN300MGII"].realtime.moldEnergyCon.toFixed(1)],
        realtimeMoldCarbonCon: [response.data["FF240"].realtime.moldCarbonCon.toFixed(1), response.data["UN160A5S"].realtime.moldCarbonCon.toFixed(1), response.data["UN300MGII"].realtime.moldCarbonCon.toFixed(1)],
        realtimeMoldMaterialCon: [response.data["FF240"].realtime.moldMaterialCon.toFixed(1), response.data["UN160A5S"].realtime.moldMaterialCon.toFixed(1), response.data["UN300MGII"].realtime.moldMaterialCon.toFixed(1)],
      }
      //datas,加上data
      this.datas = {
        ...data,
        severnDayNH: this.datas["severnDayNH"]
      };
    },
    async getSumFlowByInterval() {

      let response = await this.http.get('/custom/yzmtpf/energy/consumption/sumFlowByInterval', {
        params: {
        }
      });

      this.datas["severnDayNH"] = response.data;

    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          return;
        }
        this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header.offsetHeight - 34;
        this.gridRowHeihgt = (this.gridContainerHeight - 480) / 24;
      }, 500);
    },
  },
};
</script>
